export default {
	project_name: 'Uniglobo',
	home_drills_title: 'DRILLS',
	home_events_title: 'MY EVENTS',
	home_keep_watching_title: 'KEEP WATCHING',
	home_library_title: 'LIBRARY',
	home_live_classes_title: 'LIVE CLASSES',
	home_news_title: 'NEWS',
	home_online_courses_title: 'ONLINE COURSES',
	home_podcasts_title: 'PODCASTS',
	home_surveys_title: 'SURVEYS',
	home_tags_title: 'HIGHLIGHTS',
	home_trails_title: 'TRAILS',
	home_webinars_title: 'WEBINARS',
	navbar_about_title: 'ABOUT',
}
